<script>
import { mapActions, mapState } from 'vuex'
import {
  addToFavorite,
  removeFromFavorite,
} from '@api/like.store.service'

export default {
  name: 'AddToFavorites',

  props: {
    id: {
      type: [String, Number],
    },
    isLiked: {
      type: Boolean,
    },
},

  data() {
    return {
      target: 'product',
      isLikedLocal: this.isLiked || false,
    }
  },

  computed: {
    ...mapState('like', [
      'lastAction',
    ]),
  },

  watch: {
    lastAction: {
      deep: true,
      immediate: true,
      handler(nval) {
        if (this.target !== nval.target) return

        if (this.id === nval.added) {
          this.isLikedLocal = true
        }

        if (this.id === nval.removed) {
          this.isLikedLocal = false
        }
      },
    },
  },

  methods: {
    ...mapActions('like', [
      'setAddedId',
      'setRemovedId',
      'setTarget',
    ]),

    add() {
      const data = { product_variants: [this.id] }

      addToFavorite.execute({}, data).then(() => {
        this.setAddedId(this.id)
        this.setRemovedId(null)
        this.setTarget(this.target)
      })
    },

    async remove() {
      const data = { product_variants: [this.id] }

      removeFromFavorite.execute({}, data).then(() => {
        this.setRemovedId(this.id)
        this.setAddedId(null)
        this.setTarget(this.target)

        this.$emit('hook:remove', true)
      })
    },
  },

  render(h) {
    return this.$scopedSlots.default({
      add: () => this.add(),
      remove: () => this.remove(),
      is_added: this.isLikedLocal,
    })
  },
}
</script>
